import { combineReducers, Reducer } from 'redux'
import { get } from 'lodash'

import { Actions } from '../types'

import { ActionTypes, State, Payments } from './types'
import validateReducer, {
	initialState as validateInitialState
} from './validate/reducer'

export const initialState: State = {
	validate: validateInitialState,
	isLoading: false,
	data: {}
}

const isLoading: Reducer<boolean, Actions> = (
	state: boolean = initialState.isLoading,
	action: Actions
) => {
	switch (action.type) {
		case ActionTypes.LOAD_START:
			return true
		case ActionTypes.LOAD_SUCCESS:
		case ActionTypes.LOAD_FAIL:
			return false
		default:
			return state
	}
}

const data: Reducer<Payments, Actions> = (
	state: Payments = initialState.data,
	action: Actions
) => {
	switch (action.type) {
		case ActionTypes.LOAD_SUCCESS:
			return action.payload
		default:
			return state
	}
}

export const getters = {
	isLoading: (state: State): boolean =>
		get(state, 'isLoading', initialState.isLoading),
	data: (state: State): Payments => get(state, 'data', initialState.data)
}

export default combineReducers({
	validate: validateReducer,
	isLoading,
	data
})
